import { gql, TypedDocumentNode } from '@common/hooks';
import { OrganizationBusinessesQueryCgResponse } from '@common/graphql';

export const ORGANIZATION_BUSINESSES_QUERY: TypedDocumentNode<OrganizationBusinessesQueryCgResponse> = gql`
  query OrganizationBusinesses {
    organizationBusinesses {
      id
      name
      city
      stateCode
      organization {
        id
        name
      }
    }
  }
`;
